export var NotifPrefsAccordionActions;
(function (NotifPrefsAccordionActions) {
    NotifPrefsAccordionActions["TOGGLE_CHECKED"] = "TOGGLE_RICH_ACCORDION_ITEM_CHECKED";
    NotifPrefsAccordionActions["TOGGLE_OPENED"] = "TOGGLE_RICH_ACCORDION_ITEM_OPENED";
})(NotifPrefsAccordionActions || (NotifPrefsAccordionActions = {}));
export const toggleItemChecked = (index, checked) => (dispatch) => {
    dispatch({
        type: NotifPrefsAccordionActions.TOGGLE_CHECKED,
        index,
        checked
    });
};
export const toggleItemOpened = (index) => (dispatch) => {
    dispatch({
        type: NotifPrefsAccordionActions.TOGGLE_OPENED,
        index
    });
};
